import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
  private authLocalStorageToken = `${ environment.appVersion }-${ environment.USERDATA_KEY }`;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = JSON.parse(localStorage.getItem(this.authLocalStorageToken))?.token;
    const isApiUrl = req.url.startsWith(environment.api_host);

    if (!token || !isApiUrl) {
      return next.handle(req);
    }

    const headers = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${ token }`)
    });

    return next.handle(headers);
  }
}
